import { useRef } from 'react';
import { useInView } from 'framer-motion';
import useCountUp from '../../hooks/useCountUp';
import { formatNumber } from '../../lib/format';
import cn from '../../lib/cn';

/** Number that counts up the first time it scrolls into view. */
export default function StatCounter({ value, suffix = '', prefix = '', className }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const current = useCountUp(value, { active: inView });

  return (
    <span ref={ref} className={cn('tabular-nums', className)}>
      {prefix}
      {formatNumber(current)}
      {suffix}
    </span>
  );
}
